export const getErrorMessage = (res: any, customMessage: string) => {
  return res?.response?.data?.message ?? res?.data?.message ?? res?.message ?? customMessage;
};
